import * as R from 'ramda';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import { withBorder } from '../../../reactutils/withBorder';
import { withLogin } from '../../../reactutils/withLogin';
import { withNavLocation } from '../../../reactutils/withNavLocation';
import { withTitle } from '../../../reactutils/withTitle';
import { EmailConfirmationTeaser } from '../../AccountUserApp/EmailConfirmationTeaser';
import { InvalidEmailTeaser } from '../../AccountUserApp/InvalidEmailTeaser';
import { NewsletterTeaser } from '../../AccountUserApp/NewsletterTeaser';
import { ProfileSubMenu } from '../../AccountUserApp/ProfileSubMenu';
import { Section, SectionHeading } from '../../common/Section';
import { userNameSelector } from '../../System/selectors';
import { bettingProfileAddFavoriteTeam, bettingProfileDeleteFavoriteTeam, bettingProfileLoadBettingProfile, bettingProfileUpdateBettingPublic } from './actions';
import { FavoriteTeams } from './FavoriteTeams';
import { ProfileMyResults } from './ProfileMyResults';
import { ProfileUserGroups } from './ProfileUserGroups';
import { bettingProfileAvailableTeamsSelector, bettingProfileBettingPublicSelector, bettingProfileFavoriteTeamsSelector } from './selectors';

const BettingProfileComponent: React.FC<{}> = props => {
    const favoriteTeams = useSelector(bettingProfileFavoriteTeamsSelector);
    const availableTeams = useSelector(bettingProfileAvailableTeamsSelector);
    const bettingPublic = useSelector(bettingProfileBettingPublicSelector);

    const [bettingPublicEdit, setBettingPublicEdid] = React.useState(bettingPublic);

    const dispatch = useDispatch();
    
    const onLoad = React.useCallback(() => {
        dispatch(bettingProfileLoadBettingProfile());
    }, [dispatch]);

    const onAddFavoriteTeam = (teamId: string) => {
        dispatch(bettingProfileAddFavoriteTeam(teamId));
    };
    const onDeleteFavoriteTeam = (teamId: string) => {
        dispatch(bettingProfileDeleteFavoriteTeam(teamId));
    };
    const onUpdateVisibility = () => {
        dispatch(bettingProfileUpdateBettingPublic(bettingPublicEdit));
    };

    React.useEffect(() => {
        onLoad();
    }, [onLoad]);

    return (
        <>
            <ProfileSubMenu subMenu="betting" />
            <EmailConfirmationTeaser />
            <NewsletterTeaser />
            <InvalidEmailTeaser />
            <Section>
                <SectionHeading>Sichtbarkeit</SectionHeading>
                <Form >
                    <FormGroup check={true} inline={true}>
                        <Label check={true}>
                            <Input
                                type="checkbox"
                                name="bettingPublic"
                                checked={bettingPublicEdit}
                                onChange={() => setBettingPublicEdid(!bettingPublicEdit)}
                                className="me-3"
                            />
                            Meine Lieblingsteams und Tippteams sind für alle sichtbar
                        </Label>
                    </FormGroup>
                    <Button className="ms-3" color="success" onClick={onUpdateVisibility}>
                        Speichern
                    </Button>
                </Form>
            </Section>
            <FavoriteTeams
                favoriteTeams={favoriteTeams}
                availableTeams={availableTeams}
                onAdd={onAddFavoriteTeam}
                onDelete={onDeleteFavoriteTeam}
            />
            <ProfileUserGroups />
            <ProfileMyResults />
        </>
    );
};

export const BettingProfileScreen = R.compose(
    withBorder(),
    withTitle('Tippspiel', userNameSelector),
    withNavLocation('profile'),
    withLogin()
)(BettingProfileComponent);
